export const c_spinner_diameter = {
  "name": "--pf-v6-c-spinner--diameter",
  "value": "3.5rem",
  "var": "var(--pf-v6-c-spinner--diameter)"
};
export default c_spinner_diameter;